import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ArticleCategory } from '@/utils/types'

export default function useSeo(category?: ArticleCategory) {
  const globalStore = useGlobalStore()

  const title = `${category?.seo?.meta_title || category?.subject}｜hengstyle Life｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const url = `${import.meta.env.VITE_DOMAIN}/hence/${category?.seo.meta_slug ?? category?.id}`
  const description = globalStore.seoDescriptions.henceCategory.replace(':name', category?.subject ?? '')
  globalStore.setBreadcrumbs([
    { title: 'hengstyle Life', isActive: false, url: '/hence' },
    { title: category?.subject ?? '', isActive: true, url }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: category?.seo?.og_image?.link,
    keywords: category?.seo?.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'hengstyle Life',
            item: `${import.meta.env.VITE_DOMAIN}/hence`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: category?.subject,
            item: url
          }
        ]
      }
    ]
  })
}
